import React from 'react';
import './css/NavigationBar.css';
import { AiTwotoneGift } from 'react-icons/ai';
import { t } from 'ttag';
import { mixpanel } from './mp.js';


function NavigationBar({ handlesetIndex, index }) {

  const toggleMenuAct = (ind) => {
    handlesetIndex(ind)
  }

  return (
    <div className="navigation-bar">
      <button className={index == 0 ? "nav-button-hover" : "nav-button"} onClick={() => toggleMenuAct(0)}>{t`Home`}</button>
      <button className={index == 1 ? "nav-button-hover" : "nav-button"} onClick={() => toggleMenuAct(1)}>{t`Trade`}</button>
      <button className={index == 2 ? "nav-button-hover" : "nav-button"} onClick={() => toggleMenuAct(2)}>{t`License`}</button>
      <button className={index == 3 ? "nav-button-hover" : "nav-button"} onClick={() => toggleMenuAct(3)}>{t`Finance`}</button>
      <button className={index == 4 ? "nav-button-hover" : "nav-button"} onClick={() => toggleMenuAct(4)}>{t`Affiliate`}</button>
    </div>
  );
}

export { NavigationBar };